export function serviceIcon(baseUrl: string, service: string) {
  switch (service.toUpperCase()) {
    case 'QUESTIONBASE':
      return `${baseUrl}/favicon.ico`;
    case 'NOTION':
      return `${baseUrl}/assets/services/notion.ico`;
    case 'GOOGLE_DRIVE':
      return `${baseUrl}/assets/services/gdrive.png`;
    case 'CONFLUENCE':
      return `${baseUrl}/assets/services/confluence.ico`;
    case 'WEBCRAWLER':
      return `${baseUrl}/assets/services/webcrawler.svg`;
    default:
      throw new Error(`Unknown service: ${service}`);
  }
}
